import { millisecondsToSeconds } from 'date-fns';

function getTechnicalTime(time: string | number | null | undefined) {
    if (typeof time === 'number') {
        return time;
    }

    if (typeof time === 'string') {
        const timestamp = new Date(time).getTime();

        return !Number.isNaN(timestamp)
            ? millisecondsToSeconds(timestamp)
            : undefined;
    }

    return undefined;
}

export default getTechnicalTime;
